<template>
    
    <v-card class="booking-card mx-auto" max-width="540" outlined>

      


      <div class="booking-intro pa-6 pb-4">
        <div class="caption text-uppercase primary--text font-weight-bold mb-2">Agendamento online</div>
        <h4 class="display-1 font-weight-bold mb-2">Faça seu agendamento</h4>
        <p class="body-2 grey--text text--darken-1 mb-0">Escolha o serviço e siga as etapas para reservar seu horário.</p>
      </div>
      
      
      
      <AgradecimentoDialog :stateDialog="dialogAgradecimentoState" />
    <v-card-title class="booking-step-title title font-weight-regular justify-space-between">
      <div>
        <div class="caption text-uppercase grey--text text--darken-1 mb-1">Etapa {{ step }} de 3</div>
        <span>{{ currentTitle }}</span>
      </div>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="step">
      <v-window-item :value="1">
        <v-card-text class="pa-6">

        <v-menu
          v-model="menuServicos"
          :close-on-content-click="false"
          offset-y
          :nudge-bottom="6"
          min-width="320"
          max-width="500"
          content-class="service-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="booking-input service-select"
              :value="servicoEscolhidoObjeto.descricao || ''"
              label="Serviço"
              placeholder="Selecione um serviço"
              prepend-inner-icon="mdi-content-cut"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              hide-details
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>

          <v-card class="service-menu-card" outlined>
            <div class="service-menu__heading">
              <div>
                <div class="overline primary--text font-weight-bold mb-1">Serviços disponíveis</div>
                <div class="caption grey--text text--darken-1">Escolha o atendimento que deseja reservar</div>
              </div>
              <v-icon color="primary" small>mdi-content-cut</v-icon>
            </div>
            <v-list class="service-menu__list" two-line>
              <template v-for="item in servicos">
                <v-list-item
                  v-if="item.header"
                  :key="item.id"
                  class="service-group"
                  disabled
                >
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="primary">mdi-bookmark-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="caption font-weight-bold grey--text text--darken-3">
                      {{ item.header }}
                    </v-list-item-title>
                    <v-list-item-subtitle>Escolha uma opção</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-else
                  :key="item.id"
                  class="service-option"
                  :class="{ 'service-option--selected': item.id === servicoEscolhido }"
                  :disabled="!duracaoEmMinutos(item)"
                  @click="selecionarServico(item)"
                >
                  <v-list-item-icon class="mr-3">
                    <v-avatar size="36" color="primary lighten-5">
                      <v-icon small color="primary">mdi-content-cut</v-icon>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="service-option__name">{{ item.descricao }}</v-list-item-title>
                    <v-list-item-subtitle v-if="duracaoEmMinutos(item)" class="service-option__duration">
                      <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                      {{ formatarDuracao(item.tempo) }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-else class="service-option__duration">
                      <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
                      Indisponível para agendamento online
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="service-option__price">
                    <span>R$ {{ formatarPreco(item.preco) }}</span>
                    <v-icon v-if="item.id === servicoEscolhido" small color="primary">mdi-check</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </template>
              <v-list-item v-if="!servicos.length" disabled>
                <v-list-item-content>
                  <v-list-item-title>Carregando serviços...</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>


            <!--
          <v-text-field
            label="Email"
            value="john@vuetifyjs.com"
          ></v-text-field>
          -->
          <p class="caption grey--text text--darken-1 mt-3 mb-0">
            Selecione o serviço que você quer agendar.
          </p>

          <div v-if="servicoEscolhidoObjeto.descricao" class="selected-service mt-4">
            <div class="selected-service__header">
              <div>
                <div class="overline primary--text font-weight-bold mb-1">Serviço escolhido</div>
                <div class="subtitle-1 font-weight-bold">{{ servicoEscolhidoObjeto.descricao }}</div>
              </div>
              <v-avatar color="primary lighten-5" size="36">
                <v-icon color="primary" small>mdi-check</v-icon>
              </v-avatar>
            </div>
            <div class="selected-service__details mt-3">
              <v-chip small outlined color="primary">
                <v-icon left small>mdi-clock-outline</v-icon>
                {{ formatarDuracao(servicoEscolhidoObjeto.tempo) }}
              </v-chip>
              <v-chip small outlined color="primary">
                <v-icon left small>mdi-cash</v-icon>
                R$ {{ formatarPreco(servicoEscolhidoObjeto.preco) }}
              </v-chip>
            </div>
          </div>

        <div class="booking-field-caption mt-5">
          <v-icon small color="grey darken-1" class="mr-1">mdi-account</v-icon>
          <span>Escolha o barbeiro</span>
        </div>
        <v-menu
          v-model="menuBarbeiros"
          :close-on-content-click="false"
          :disabled="!servicoEscolhido || !barbeirosFiltrados.length"
          offset-y
          :nudge-bottom="6"
          min-width="320"
          max-width="500"
          content-class="barber-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="booking-input barber-select"
              :value="barbeiroEscolhidoObjeto.nome || ''"
              label="Barbeiro"
              :placeholder="servicoEscolhido ? 'Selecione um barbeiro' : 'Escolha o serviço primeiro'"
              prepend-inner-icon="mdi-account"
              append-icon="mdi-chevron-down"
              readonly
              outlined
              hide-details
              :disabled="!servicoEscolhido || !barbeirosFiltrados.length"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>

          <v-card class="barber-menu-card" outlined>
            <div class="barber-menu__heading">
              <div>
                <div class="overline primary--text font-weight-bold mb-1">Profissionais disponíveis</div>
                <div class="caption grey--text text--darken-1">Escolha quem fará seu atendimento</div>
              </div>
              <v-icon color="primary" small>mdi-account-check-outline</v-icon>
            </div>
            <v-list class="barber-menu__list" two-line>
              <v-list-item
                v-for="item in barbeirosFiltrados"
                :key="item.id"
                class="barber-option"
                :class="{ 'barber-option--selected': item.id === barbeiroEscolhido }"
                @click="selecionarBarbeiro(item)"
              >
                <v-list-item-icon class="mr-3">
                  <v-avatar size="38" color="primary lighten-5">
                    <span class="primary--text font-weight-bold">{{ iniciaisBarbeiro(item.nome) }}</span>
                  </v-avatar>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="barber-option__name">{{ item.nome }}</v-list-item-title>
                  <v-list-item-subtitle>Disponível para este serviço</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon v-if="item.id === barbeiroEscolhido" small color="primary">mdi-check-circle</v-icon>
                  <v-icon v-else small color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item v-if="!barbeirosFiltrados.length" disabled>
                <v-list-item-content>
                  <v-list-item-title>Nenhum barbeiro disponível para este serviço</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <div v-if="servicoEscolhido && !barbeirosFiltrados.length" class="empty-barber-state mt-3">
          <v-icon small color="warning darken-2" class="mr-2">mdi-information-outline</v-icon>
          <span>Nenhum barbeiro atende este serviço no momento.</span>
        </div>

        </v-card-text>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-text class="pa-6">
          <div class="booking-context mb-5">
            <div class="booking-context__item">
              <v-icon small color="primary" class="mr-2">mdi-content-cut</v-icon>
              <div>
                <div class="caption grey--text text--darken-1">Serviço</div>
                <div class="body-2 font-weight-medium">{{ servicoEscolhidoObjeto.descricao }}</div>
              </div>
            </div>
            <div class="booking-context__item">
              <v-icon small color="primary" class="mr-2">mdi-account</v-icon>
              <div>
                <div class="caption grey--text text--darken-1">Barbeiro</div>
                <div class="body-2 font-weight-medium">{{ barbeiroEscolhidoObjeto.nome }}</div>
              </div>
            </div>
          </div>

          <div class="booking-field-caption">
            <v-icon small color="grey darken-1" class="mr-1">mdi-calendar</v-icon>
            <span>Escolha a data</span>
          </div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
            content-class="date-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="booking-input mt-2"
                :value="formatarData(date)"
                label="Data do atendimento"
                placeholder="Selecione uma data"
                prepend-inner-icon="mdi-calendar"
                append-icon="mdi-chevron-down"
                readonly
                outlined
                hide-details
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              class="date-picker"
              :min="minDate"
              v-model="date"
              locale="pt-br"
              color="primary"
              header-color="primary"
              no-title
              scrollable
              @change="gerarHorariosDisponiveis"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Fechar</v-btn>
            </v-date-picker>
          </v-menu>

          <div v-if="date" class="date-selection mt-3">
            <v-avatar color="primary lighten-5" size="38">
              <v-icon small color="primary">mdi-calendar-check</v-icon>
            </v-avatar>
            <div class="date-selection__content">
              <div class="caption grey--text text--darken-1">Data selecionada</div>
              <div class="body-2 font-weight-bold">{{ formatarDataLonga(date) }}</div>
            </div>
            <v-chip v-if="!carregandoHorarios && !fecharAgenda" small outlined color="primary">
              {{ horariosFiltrados.length }} {{ horariosFiltrados.length === 1 ? 'horário' : 'horários' }}
            </v-chip>
          </div>

          <div v-if="fecharAgenda" class="availability-alert mt-3">
            <v-icon small color="error" class="mr-2">mdi-calendar-remove</v-icon>
            <span>Este dia não terá expediente para o barbeiro escolhido.</span>
          </div>

          <div class="booking-field-caption mt-5">
            <v-icon small color="grey darken-1" class="mr-1">mdi-clock-outline</v-icon>
            <span>Escolha o horário</span>
          </div>
          <v-menu
            v-model="menuHorarios"
            :close-on-content-click="false"
            :disabled="!date || carregandoHorarios || !horariosFiltrados.length"
            offset-y
            :nudge-bottom="6"
            min-width="320"
            max-width="500"
            content-class="time-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="booking-input mt-2"
                :value="horarioEscolhido"
                label="Horário do atendimento"
                :placeholder="carregandoHorarios ? 'Carregando horários...' : 'Selecione um horário'"
                prepend-inner-icon="mdi-clock-outline"
                append-icon="mdi-chevron-down"
                readonly
                outlined
                hide-details
                :disabled="!date || carregandoHorarios || !horariosFiltrados.length"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-card class="time-menu-card" outlined>
              <div class="time-menu__heading">
                <div>
                  <div class="overline primary--text font-weight-bold mb-1">Horários livres</div>
                  <div class="caption grey--text text--darken-1">Selecione o melhor horário para você</div>
                </div>
                <v-chip x-small outlined color="primary">{{ horariosFiltrados.length }} disponíveis</v-chip>
              </div>
              <div class="time-menu__list">
                <v-btn
                  v-for="horario in horariosFiltrados"
                  :key="horario"
                  class="time-option"
                  :class="{ 'time-option--selected': horario === horarioEscolhido }"
                  :outlined="horario !== horarioEscolhido"
                  :color="horario === horarioEscolhido ? 'primary' : undefined"
                  depressed
                  @click="selecionarHorario(horario)"
                >
                  <v-icon small class="mr-2">mdi-clock-outline</v-icon>
                  {{ horario }}
                </v-btn>
              </div>
            </v-card>
          </v-menu>

          <div v-if="carregandoHorarios" class="loading-availability mt-3">
            <v-progress-circular indeterminate size="18" width="2" color="primary" class="mr-2"></v-progress-circular>
            <span>Consultando horários livres...</span>
          </div>
          <div v-else-if="erroHorarios" class="availability-alert availability-alert--warning mt-3">
            <v-icon small color="warning darken-2" class="mr-2">mdi-alert-outline</v-icon>
            <span>{{ erroHorarios }}</span>
          </div>
          <div v-else-if="date && !fecharAgenda && !horariosFiltrados.length" class="availability-alert availability-alert--warning mt-3">
            <v-icon small color="warning darken-2" class="mr-2">mdi-calendar-clock</v-icon>
            <span>Não há horários livres para este dia. Escolha outra data.</span>
          </div>

       
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
        <div class="booking-details pa-6">
          <div class="booking-confirmation-summary mb-5">
            <div class="booking-confirmation-summary__title">
              <v-icon small color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
              <span>Confira seu agendamento</span>
            </div>
            <div class="booking-confirmation-summary__grid">
              <div>
                <div class="caption grey--text text--darken-1">Serviço</div>
                <div class="body-2 font-weight-bold">{{ servicoEscolhidoObjeto.descricao }}</div>
              </div>
              <div>
                <div class="caption grey--text text--darken-1">Barbeiro</div>
                <div class="body-2 font-weight-bold">{{ barbeiroEscolhidoObjeto.nome }}</div>
              </div>
              <div>
                <div class="caption grey--text text--darken-1">Data e horário</div>
                <div class="body-2 font-weight-bold">{{ formatarData(date) }} às {{ horarioEscolhido }}</div>
              </div>
            </div>
          </div>

          <div class="booking-details__intro text-center">
            <h3 class="title font-weight-light mb-2">Falta pouco!</h3>
            <p class="body-2 grey--text text--darken-1 mb-0">Informe seus dados para confirmar a reserva.</p>
          </div>
          <v-layout row wrap class="mt-4" >
            <v-flex xs12 sm6 class="px-2" >
              <v-text-field class="booking-input" label="Nome" prepend-inner-icon="mdi-account" outlined hide-details v-model="user.nome" ></v-text-field>
            </v-flex>
          <v-flex xs12 sm6 class="px-2" >
                <!-- <v-text-field label="telefone" type="text" prepend-icon="fa fa-phone" placeholder="(00)00000-0000 " v-model="user.telefone" ></v-text-field> -->
              <v-text-field class="booking-input" label="Telefone" v-mask="'(##)#####-####'" type="text" prepend-inner-icon="mdi-phone" placeholder="(00)00000-0000" outlined hide-details v-model="user.telefone" ></v-text-field>

            </v-flex>

            <v-flex xs12 sm12 class="px-2" >
              <v-text-field class="booking-input" label="E-mail" :rules="emailRules" type="email" prepend-inner-icon="mdi-email-outline" outlined hide-details="auto" v-model="user.email" ></v-text-field>
            </v-flex>

          </v-layout>
          
        </div>
      </v-window-item>

      
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1"
        text
        @click="step--"
      >
        Voltar
      </v-btn>
     
      <v-spacer></v-spacer>
      <v-btn
        v-if="!(step == 3)"
        :disabled="checarBotao()"
        color="primary"
        depressed
        @click="step++"
        
        
      >
        Próximo
      </v-btn>
      <v-btn class="success"  v-if="(step == 3)" :loading="enviandoAgendamento" :disabled="checarBotaoEnviar() || enviandoAgendamento" @click="enviarAgendamento" >
        Concluir!
      </v-btn>
    </v-card-actions>
  </v-card>
  
</template>

<script>
//import firebase from 'firebase'
import {refAgenda, refBarbeiros,refFuncoes, refFeriados, refConfiguracoes} from '@/firebaseConfig'
import AgradecimentoDialog from './AgradecimentoDialog'
import { criarAgendamentoNoPortal } from '@/services/agendaFirestore'

//import {mapActions} from 'vuex'
    export default {
      components: {
        AgradecimentoDialog
      },
      
    data: () => ({

      refServicos: refFuncoes,
      refBarbeiros: refBarbeiros,
      refAgenda: refAgenda,
      refFeriados: refFeriados,
      refConfiguracoes: refConfiguracoes,
      // listaHorariosExibir: [],
      fecharAgenda: false,
      user: {telefone:'', nome: '', email:''},
      date:'', //new Date().toISOString().substr(0, 10),
      minDate: new Date().toISOString().substr(0, 10),
      ajusteHoras: -10800000,
      menu: false,
      menuServicos: false,
      menuBarbeiros: false,
      menuHorarios: false,
      today: null,
      step: 1,
      servicos: [],
      barbeiros:[],
      events : [],
      horariosFiltrados:[],
      barbeirosFiltrados: [],
      horarioEscolhido: "",
      servicoEscolhido: "",
      barbeiroEscolhido: "",
      barbeiroEscolhidoObjeto: {},
      servicoEscolhidoObjeto: {},
      carregandoHorarios: false,
      erroHorarios: '',
      requisicaoHorarios: 0,
      dialogAgradecimentoState: false,
      agendamentoPronto: '',
      enviandoAgendamento: false,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail precisa ser válido',
      ],

    }),
   created(){
      
        this.carregarServicos();
        this.carregarBarbeiros();
       
    },
    methods: {
      
        //  ...mapActions(),
          campoVazio(value){
            return value === '' || typeof value === 'undefined' || value == null
          },

          formatarDuracao(tempo){
            const minutos = Number.parseInt(String(tempo || '').replace(/[^0-9]/g, ''), 10)
            if(Number.isNaN(minutos)){
              return tempo || ''
            }

            if(minutos >= 60){
              const horas = Math.floor(minutos / 60)
              const restante = minutos % 60
              return horas + 'h' + (restante ? (restante < 10 ? '0' : '') + restante : '')
            }

            return minutos + ' min'
          },

          formatarPreco(preco){
            const valor = Number(String(preco || '').replace(',', '.'))
            if(Number.isNaN(valor)){
              return preco || ''
            }

            return valor.toFixed(2).replace('.', ',')
          },

          formatarData(data){
            if(!data){
              return ''
            }

            const partes = String(data).split('-')
            if(partes.length !== 3){
              return data
            }

            return partes[2] + '/' + partes[1] + '/' + partes[0]
          },

          formatarDataLonga(data){
            if(!data){
              return ''
            }

            const dataLocal = new Date(data + 'T12:00:00')
            if(Number.isNaN(dataLocal.getTime())){
              return this.formatarData(data)
            }

            return dataLocal.toLocaleDateString('pt-BR', {
              weekday: 'long',
              day: '2-digit',
              month: 'long',
              year: 'numeric'
            })
          },

          iniciaisBarbeiro(nome){
            const partes = String(nome || '').trim().split(/\s+/).filter(Boolean)
            if(!partes.length){
              return '?'
            }

            return partes
              .slice(0, 2)
              .map(parte => parte.charAt(0).toUpperCase())
              .join('')
          },

          checarBotao(){
            if(this.step == 1){
              return  this.campoVazio(this.servicoEscolhido) ||  this.campoVazio(this.barbeiroEscolhido)
              
            }else if(this.step == 2){
              return this.campoVazio(this.date) || this.campoVazio(this.horarioEscolhido)
            }

          },

          checarBotaoEnviar(){
            return this.campoVazio(this.user.telefone)
            || this.campoVazio(this.user.nome)
            || this.campoVazio(this.user.email)
          },

          zerarHorarios(){
              this.horariosFiltrados = [];
              this.horarioEscolhido = ''
              this.erroHorarios = ''
              //this.date = null
          },

          //Duração do serviço em minutos. Retorna null quando o cadastro está
          //inválido/ausente, para que o serviço seja bloqueado em vez de gerar
          //uma grade de horários sem filtro.
          duracaoEmMinutos(servico){
              if(!servico || servico.header){
                return null
              }

              const tempo = servico.tempo === undefined || servico.tempo === null ? '' : servico.tempo
              const minutos = parseFloat(String(tempo).replace("m",""))
              return Number.isFinite(minutos) && minutos > 0 ? minutos : null
          },

          selecionarServico(servico){
              if(!this.duracaoEmMinutos(servico)){
                return
              }

              this.servicoEscolhido = servico.id
              this.servicoEscolhidoObjeto = {...servico}
              this.menuServicos = false
              this.ajustarBarbeiros()
          },

          selecionarBarbeiro(barbeiro){
              if(!barbeiro){
                return
              }

              this.barbeiroEscolhido = barbeiro.id
              this.zerarHorarios()
              this.barbeiroEscolhidoObjeto = {...barbeiro}
              this.menuBarbeiros = false
              this.date = ''
              this.fecharAgenda = false
          },

          selecionarHorario(horario){
              this.horarioEscolhido = horario
              this.menuHorarios = false
          },

          buscarAgenda(){
              this.events = []
              this.refAgenda.where("barbeiro.id", '==', this.barbeiroEscolhido).get().then((snap)=> {
                  snap.forEach((doc)=>{
                      this.events.push({...doc.data()})
                  });
              });
                
            },
          
          carregarServicos(){

              this.refServicos.get().then((snap)=>{
                const lista = []
                snap.forEach((doc)=>{
                  const servico = {...doc.data(), id: doc.id}
                  var descricaoTempo = servico.descricao + " - " + this.formatarDuracao(servico.tempo) + " - R$ " + this.formatarPreco(servico.preco)
                  lista.push({...servico, descTempo: descricaoTempo})
                })

                const ordenar = (a, b) => Number(a.ordem || 999) - Number(b.ordem || 999)
                const principais = lista
                  .filter(servico => servico.grupo === "principais")
                  .sort(ordenar)
                const novos = lista
                  .filter(servico => servico.grupo !== "principais")
                  .sort(ordenar)

                this.servicos = principais
                if(novos.length){
                  const grupos = []
                  novos.forEach((servico) => {
                    const nomeGrupo = (servico.grupoNome || "Novos serviços").trim() || "Novos serviços"
                    let grupo = grupos.find((item) => item.nome === nomeGrupo)
                    if(!grupo){
                      grupo = {
                        nome: nomeGrupo,
                        ordem: Number(servico.ordem || 999),
                        servicos: []
                      }
                      grupos.push(grupo)
                    }
                    grupo.servicos.push(servico)
                  })

                  grupos
                    .sort((a, b) => a.ordem - b.ordem)
                    .forEach((grupo, index) => {
                      this.servicos.push({
                        id: "__grupo_servicos_" + index,
                        header: grupo.nome,
                        disabled: true
                      })
                      this.servicos.push(...grupo.servicos.sort(ordenar))
                    })
                }
              });
            },
            carregarBarbeiros(){
            this.refBarbeiros.orderBy("nome","asc").get().then((snap)=>{
                    snap.forEach((doc)=>{
                      
                      this.barbeiros.push({...doc.data()});
                    });

                  });
            },
            ajustarBarbeiros(){
              this.barbeirosFiltrados = [];
              this.barbeiroEscolhido = ''
              this.barbeiroEscolhidoObjeto = {}
              this.date = ''
              this.menuBarbeiros = false
              this.menuHorarios = false
              this.fecharAgenda = false
              this.zerarHorarios()
              this.barbeirosFiltrados = this.barbeiros.filter(barbeiro => {
                const funcoes = Array.isArray(barbeiro.funcoes) ? barbeiro.funcoes : []
                return funcoes.includes(this.servicoEscolhido)
              })
              this.servicoEscolhidoObjeto = this.filtrarServico() || {}

              //console.log(this.barbeirosFiltrados);
              },
            
            async gerarHorariosDisponiveis(){
              //Token da requisição: como o método é assíncrono e faz várias
              //leituras no Firestore, trocas rápidas de data podiam misturar os
              //horários de dias diferentes. Só a última chamada escreve na tela.
              const requisicao = ++this.requisicaoHorarios
              const dataRequisicao = this.date

              this.horarioEscolhido = ''
              this.horariosFiltrados = []
              this.fecharAgenda = false
              this.erroHorarios = ''
              this.carregandoHorarios = false

              if(!dataRequisicao || !this.barbeiroEscolhido || !this.servicoEscolhido){
                return
              }

              this.carregandoHorarios = true
              try {
                const barbeiro = this.filtrarBarbeiro() || {}
                const servico = this.filtrarServico() || {}
                this.barbeiroEscolhidoObjeto = barbeiro
                this.servicoEscolhidoObjeto = servico

                const minutosServico = this.duracaoEmMinutos(servico)
                if(!minutosServico){
                  this.erroHorarios = 'Este serviço está sem a duração cadastrada. Escolha outro serviço ou fale com a barbearia.'
                  return
                }

                const dataLocal = new Date(dataRequisicao + 'T12:00:00')
                const diaSemana = dataLocal.getDay()
                const indiceHorario = diaSemana === 0 ? 6 : diaSemana - 1
                const horarios = Array.isArray(barbeiro.horarios)
                  ? barbeiro.horarios
                  : []
                const diaBarbeiro = horarios[indiceHorario]

                if(!diaBarbeiro || !diaBarbeiro.horaIni || !diaBarbeiro.horaFim){
                  this.fecharAgenda = true
                  return
                }

                const fechadoPorFeriado = await this.checarFeriados(dataRequisicao, barbeiro.id)
                if(requisicao !== this.requisicaoHorarios){
                  return
                }
                if(fechadoPorFeriado){
                  this.fecharAgenda = true
                  return
                }

                let lista = await this.gerarListaHorarios(dataRequisicao, diaBarbeiro, minutosServico)
                lista = await this.verificarHorasDisponiveis(dataRequisicao, diaBarbeiro, minutosServico, lista)

                if(requisicao !== this.requisicaoHorarios){
                  return
                }

                //ordena do menor pro maior
                this.horariosFiltrados = lista.sort((a,b) => a < b ? -1 : 1)
              } catch (error) {
                //Qualquer falha aqui precisa deixar a lista VAZIA. Antes a exceção
                //saía silenciosamente e a grade ficava sem nenhum filtro aplicado.
                if(requisicao === this.requisicaoHorarios){
                  this.horariosFiltrados = []
                  this.erroHorarios = 'Não foi possível carregar os horários agora. Escolha a data novamente.'
                }
              } finally {
                if(requisicao === this.requisicaoHorarios){
                  this.carregandoHorarios = false
                  if(this.$refs.menu && this.$refs.menu.save){
                    this.$refs.menu.save(this.date)
                  }
                }
              }

            },

            corrigirHorarioLocale(dia, hora){
              console.log(dia, hora);
              // let correcaoHorario = (180 * 60 * 1000)
              // let reducaoHorario = new Date().getTimezoneOffset() * 60 * 1000
              // let dateTimeIni = new Date(dia + "T" + hora).getTime() - reducaoHorario + correcaoHorario
              // return dateTimeIni + " " + new Date(dateTimeIni)
              // console.log(dateTimeIni);
              return new Date("2020-10-16T11:00-03:00").getTime()
              
            },
            async gerarListaHorarios(data, diaBarbeiro, minutosServico){
              let dateTimeIni = new Date(data + "T" + diaBarbeiro.horaIni+"-03:00").getTime()
              let dateTimeFim = new Date(data + "T" + diaBarbeiro.horaFim+"-03:00").getTime()

              //Expediente com horário inválido/invertido não gera grade nenhuma
              if(!Number.isFinite(dateTimeIni) || !Number.isFinite(dateTimeFim) || dateTimeFim <= dateTimeIni){
                return []
              }

              const lista = await this.gerarHorariosDiaV2(dateTimeIni,dateTimeFim)

              const tempoServicoMilliSeconds = ((minutosServico * 60) * 1000);
              const horaAlmocoIni = new Date(data + "T" + diaBarbeiro.almocoIni+"-03:00").getTime()
              const horaAlmocoFim = new Date(data + "T" + diaBarbeiro.almocoFim+"-03:00").getTime()
              const horaExpedienteFim = dateTimeFim
              const agora = Date.now()

              return lista.filter((hora) =>{
                    var horaVisivel = new Date(data + "T" + hora+"-03:00").getTime();

                    //Horário que não pôde ser interpretado nunca é oferecido
                    if(!Number.isFinite(horaVisivel)){
                      return false
                    }

                    var horaVisivelFinal = horaVisivel + tempoServicoMilliSeconds;

                    //Esconder horários que já passaram (vale para o dia de hoje)
                    if(horaVisivel <= agora){
                      return false
                    }
                    if(horaVisivel >= horaAlmocoIni && horaVisivel < horaAlmocoFim || horaVisivelFinal > horaAlmocoIni && horaVisivelFinal <= horaAlmocoFim){
                      return false
                    }
                    //Esconder horário de FIM com base no horario escolhido e também no término do serviço
                    if(horaVisivelFinal > horaExpedienteFim){
                      return false
                    }
                    return true
              });
            },

          async gerarHorariosDiaV2(dateTimeIni,dateTimeFim){
            let minutosExibir = await this.totalHorariosExibir()
            let dateTimeDiff = dateTimeFim - dateTimeIni;
            let mult = (minutosExibir * 60 )* 1000
            let ciclo = dateTimeDiff / mult
            let atual = dateTimeIni
            const lista = []

            for(var i = 0; i <= ciclo; i++){
              const referencia = new Date(atual)
              //Tudo é montado em -03:00, então a hora local da barbearia é
              //sempre UTC-3 (o "+ 21" evita hora negativa depois das 21h).
              let horaAdicionar = (referencia.getUTCHours() + 21) % 24
              let minutoAdicionar = referencia.getUTCMinutes()

              horaAdicionar = horaAdicionar < 10 ? "0" + horaAdicionar.toString() : horaAdicionar.toString()
              minutoAdicionar = minutoAdicionar < 10 ? "0" + minutoAdicionar.toString() : minutoAdicionar.toString()

              lista.push(horaAdicionar + ":"+ minutoAdicionar);
              atual = atual + mult;
            }

            return lista
          },
          gerarHorariosDia(quarterHours, horaInicial,diaBarbeiro,i,diffHoras){
             let stringHour = '';
                   // console.log('i', i);
                  //  console.log('dif',diffHoras);
                    quarterHours.forEach(quart =>{
                      let minutoInicio= parseInt(diaBarbeiro.horaIni.split(":")[1])
                      let minutoFim= parseInt(diaBarbeiro.horaFim.split(":")[1])
                      let quartInt = parseInt(quart)
                      //se for primeiro horario
                      //preciso exibir somente os minutos de abertura
                      if(i == horaInicial ){
                        
                        if(quartInt >= minutoInicio ){
                            stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                            this.horariosFiltrados.push(stringHour)
                        }
                      }else{
                        if(i == (diffHoras + horaInicial)){
                         
                        if(quartInt  <= minutoFim){
                            stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                            this.horariosFiltrados.push(stringHour)
                        }
                        }else{
                        
                        stringHour =  i < 10 ? `0${i}:${quart}` : `${i}:${quart}`
                        this.horariosFiltrados.push(stringHour)
                        }
                      }
                      
                    });

          },
            async checarFeriados(data, barbeiroId){
              var feriadoBuscado = await refFeriados.where("data","==",data).get();
              var fecharAgenda = false;

              if(feriadoBuscado.docs[0]){

                //console.log(feriadoBuscado.docs[0].data());
                feriadoBuscado.docs[0].data().barbeiros.forEach(barb=>{
                  if(barb.id === barbeiroId){
                    fecharAgenda = true
                  }
                })
               /* feriadoBuscado.docs.forEach((val)=>{
                  console.log();
                });*/this.date
               // console.log(feriadoBuscado.docs[0]["barbeiros"]);
              }
              return fecharAgenda
            },
            filtrarBarbeiro(){
              return this.barbeiros.find(barbeiro => {
                  if(barbeiro.id == this.barbeiroEscolhido){
                    //barbeiroAtual = barbeiro;
                    return barbeiro
                  }});
            },


            filtrarServico(){
            return this.servicos.find(servico => {
                  if(servico.id == this.servicoEscolhido){
                    return servico;
                  }});
            },

          async enviarAgendamento(){
            if(this.enviandoAgendamento){
              return
            }

            this.enviandoAgendamento = true
            try {
              const horaFinal = this.calcularHoraFinal()
              const agenda = await criarAgendamentoNoPortal({
                barbeiro: {...this.barbeiroEscolhidoObjeto},
                servico: {...this.servicoEscolhidoObjeto},
                cliente: {...this.user},
                name: this.user.nome + " p/ " + this.barbeiroEscolhidoObjeto.nome,
                start: this.date + "T" + this.horarioEscolhido,
                end: this.date + "T" + horaFinal,
                dataQuery: new Date(this.date + "T00:00-03:00").getTime(),
                status: "Pendente",
                searchTermsArray: this.gerarTermosParaPesquisa(),
              })

              this.$store.dispatch('addAgendamento', agenda)
              this.dialogAgradecimentoState = true
            } catch (error) {
              if(error.status === 409){
                this.horarioEscolhido = ''
                await this.gerarHorariosDisponiveis()
              }
              this.$toasted.global.defaultError({ msg: error.message })
            } finally {
              this.enviandoAgendamento = false
            }
          },
           gerarTermosParaPesquisa(){
            //gerar termos para pesquisa
            let searchTermsArray = this.user.nome.split(" ")
            searchTermsArray = searchTermsArray.map(term => {
              term = term.toLowerCase();
              term = term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

              return term
            });

            return searchTermsArray;

      },
          calcularHoraFinal(){
            var minutosServico = this.duracaoEmMinutos(this.servicoEscolhidoObjeto);

            if(!minutosServico){
              throw new Error('Este serviço está sem a duração cadastrada. Escolha outro serviço ou fale com a barbearia.')
            }

            return this.addMinutos(this.horarioEscolhido,minutosServico)
          },

          addMinutos(horaIni, minutos){
            //60
            //assumino horaIni como 13:20
            let horaIniC = parseFloat(horaIni.split(":")[0])
            let minTotal = parseFloat(horaIni.split(":")[1]) + minutos
            // 60 + 20 = 80 minutos
            let horaFinal = Math.floor(minTotal / 60);
            let minFinal = minTotal % 60
            horaFinal = horaIniC + horaFinal

            horaFinal = horaFinal < 10 ? "0" + horaFinal.toString() : horaFinal.toString()
            minFinal = minFinal < 10 ? "0" + minFinal.toString() : minFinal.toString()

            var timeFinal = horaFinal + ":" + minFinal
            return timeFinal

          },

          async totalHorariosExibir(){
            const snapshot = await refConfiguracoes.get()
            const configuracaoHorarios = snapshot.docs
              .map(doc => doc.data())
              .find(configuracao => configuracao && configuracao.listaHorarios !== undefined)

            const minutos = Number(configuracaoHorarios && configuracaoHorarios.listaHorarios)
            return Number.isFinite(minutos) && minutos > 0 ? minutos : 20
          },
          async verificarHorasDisponiveis(data, diaBarbeiro, minutosServico, lista){
            //transformo a data em milisecondes
            var milliseconds = new Date(data+"T00:00-03:00").getTime()
            //busco na agenda todas as horas que já foram cadastradas

            const snap = await this.refAgenda
              .where("dataQuery",">=", milliseconds)
              .where("dataQuery","<=", milliseconds)
              .where("barbeiro.id", "==", this.barbeiroEscolhidoObjeto.id)
              .get()

                var tempoServicoMilliSeconds = ((minutosServico * 60) * 1000);
                const ocupados = []

                snap.forEach((doc)=>{
                  //pego o inicio e o final do agendamento (hora inicial e final)
                  const agendamento = doc.data()
                  let start = String(agendamento.start || '').replace(" ","T")
                  let end = String(agendamento.end || '').replace(" ","T")

                  var timeInit = new Date(start+"-03:00").getTime()
                  var timeFim = new Date(end+"-03:00").getTime()

                  //Agendamento com data ilegível é ignorado (não trava a grade)
                  if(Number.isFinite(timeInit) && Number.isFinite(timeFim)){
                    ocupados.push({timeInit, timeFim})
                  }
                });

                if(!ocupados.length){
                  return lista
                }

                return lista.filter((hora)=>{
                  //transformo cada horário da agenda em miliseconds (junto com a data escolhida)
                  var horaVisivel = new Date(data + "T" + hora+"-03:00").getTime();
                  var horaVisivelFinal = horaVisivel + tempoServicoMilliSeconds;

                  // Checa se os horários estão batendo com AGENDAMENTOS (inicio, FIM ou serviço que engloba o agendamento)
                  const conflita = ocupados.some(({timeInit, timeFim}) =>
                    horaVisivel >= timeInit && horaVisivel < timeFim ||
                    horaVisivelFinal > timeInit && horaVisivelFinal <= timeFim ||
                    horaVisivel < timeInit && horaVisivelFinal > timeFim
                  )

                  return !conflita
                })
          }
            
       
    },
    computed: {
      
      currentTitle () {
        switch (this.step) {
          case 1: return 'Serviço e barbeiro'
          case 2: return 'Data e horário'
          case 3: return 'Seus dados'
          default: return 'Agendamento realizado!'
        }
      },
      
    },
    
    
    }
</script>

<style lang="scss">
.booking-card {
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: 0 14px 34px rgba(30, 55, 90, 0.12) !important;
}

.booking-intro {
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
  border-bottom: 1px solid #e1e8f2;
}

.booking-step-title {
  min-height: 76px;
  border-bottom: 1px solid #edf0f5;
}

.service-select .v-input__slot {
  border-radius: 12px !important;
}

.service-selection {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  min-width: 0;
}

.service-selection__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.service-selection__meta {
  color: #718096;
  font-size: 12px;
  margin-top: 3px;
}

.barber-select .v-input__slot {
  border-radius: 12px !important;
}

.barber-selection {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.barber-selection__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.selected-service {
  background: #f7faff;
  border: 1px solid #dce7fa;
  border-radius: 14px;
  padding: 16px;
}

.selected-service__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.selected-service__details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.selected-service__details .v-chip {
  margin: 0;
}

.booking-field-caption {
  align-items: center;
  color: #596579;
  display: flex;
  font-size: 13px;
  font-weight: 600;
}

.booking-input .v-input__slot {
  border-radius: 12px !important;
}

.availability-alert {
  align-items: center;
  background: #fff1f1;
  border: 1px solid #ffcaca;
  border-radius: 10px;
  color: #a12b2b;
  display: flex;
  font-size: 12px;
  padding: 10px 12px;
}

.service-menu,
.barber-menu,
.time-menu,
.date-menu {
  background: transparent !important;
  box-shadow: none !important;
  margin-top: 8px;
  max-height: none !important;
  overflow: visible !important;
}

.service-menu-card,
.barber-menu-card,
.time-menu-card {
  border-radius: 14px !important;
  box-shadow: 0 14px 34px rgba(30, 55, 90, 0.18) !important;
  max-width: calc(100vw - 32px);
  overflow: hidden;
}

.service-menu__heading,
.barber-menu__heading,
.time-menu__heading {
  align-items: center;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
  border-bottom: 1px solid #e5eaf2;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
}

.service-menu__list,
.barber-menu__list {
  max-height: min(56vh, 440px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 6px 0;
  -webkit-overflow-scrolling: touch;
}

.service-menu__list::-webkit-scrollbar,
.barber-menu__list::-webkit-scrollbar,
.time-menu__list::-webkit-scrollbar {
  width: 8px;
}

.service-menu__list::-webkit-scrollbar-thumb,
.barber-menu__list::-webkit-scrollbar-thumb,
.time-menu__list::-webkit-scrollbar-thumb {
  background: #c5d1e2;
  border: 2px solid #ffffff;
  border-radius: 8px;
}

.service-menu .service-group {
  background: #f6f8fc;
  border-bottom: 1px solid #e5eaf2;
  border-left: 4px solid #1976d2;
  border-top: 1px solid #e5eaf2;
  color: #52627a !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-top: 6px;
  min-height: 52px;
  opacity: 1;
  pointer-events: none;
  text-transform: uppercase;
}

.service-menu .service-group:first-child {
  border-top: 0;
  margin-top: 0;
}

.service-menu .service-group .v-list-item__subtitle {
  color: #8a96a8 !important;
  font-size: 11px;
  margin-top: 2px;
}

.service-menu .service-option {
  min-height: 70px;
  transition: background-color 0.15s ease;
}

.service-menu .service-option:hover {
  background: #f5f8ff;
}

.service-menu .service-option--selected,
.barber-menu .barber-option--selected {
  background: #eef4ff;
}

.service-menu .service-option__name {
  color: #26354d;
  font-size: 14px;
  font-weight: 600;
  white-space: normal;
}

.service-menu .service-option__duration {
  align-items: center;
  color: #7b8798 !important;
  display: flex;
  font-size: 12px;
  margin-top: 4px;
}

.service-menu .service-option__price {
  align-items: center;
  color: #1976d2;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  gap: 8px;
  margin-left: 12px;
}

.barber-menu .barber-option {
  min-height: 68px;
  transition: background-color 0.15s ease;
}

.barber-menu .barber-option:hover {
  background: #f5f8ff;
}

.barber-menu .barber-option--selected:hover {
  background: #e6efff;
}

.barber-menu .barber-option__name {
  color: #26354d;
  font-size: 14px;
  font-weight: 600;
}

.barber-menu .v-list-item__subtitle {
  color: #7b8798 !important;
  font-size: 12px;
  margin-top: 3px;
}

.time-menu__list {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  max-height: min(46vh, 320px);
  overflow-x: hidden;
  overflow-y: auto;
  padding: 14px;
  -webkit-overflow-scrolling: touch;
}

.time-option {
  border-radius: 10px !important;
  justify-content: flex-start;
  margin: 0 !important;
  min-height: 42px !important;
  padding: 0 10px !important;
  text-transform: none;
}

.time-option:not(.time-option--selected) {
  background: #f8fafc !important;
  border-color: #dce4ef !important;
  color: #34445b !important;
}

.booking-context {
  background: #f7faff;
  border: 1px solid #dce7fa;
  border-radius: 12px;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 12px 14px;
}

.booking-context__item {
  align-items: center;
  display: flex;
  min-width: 0;
}

.booking-context__item > div {
  min-width: 0;
}

.booking-context__item .body-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-selection {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e3e9f2;
  border-radius: 12px;
  display: flex;
  gap: 10px;
  padding: 10px 12px;
}

.date-selection__content {
  flex: 1;
  min-width: 0;
}

.date-selection__content .body-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.loading-availability {
  align-items: center;
  color: #596579;
  display: flex;
  font-size: 12px;
}

.availability-alert--warning {
  background: #fff8e1;
  border-color: #ffe0a3;
  color: #7a5a00;
}

.booking-confirmation-summary {
  background: #f7faff;
  border: 1px solid #dce7fa;
  border-radius: 14px;
  padding: 14px 16px;
}

.booking-confirmation-summary__title {
  align-items: center;
  color: #26354d;
  display: flex;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 14px;
}

.booking-confirmation-summary__grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.booking-confirmation-summary__grid > div:last-child {
  grid-column: 1 / -1;
}

.booking-details__intro {
  margin-bottom: 4px;
}

.booking-card > .v-card__actions {
  background: #fbfcfe;
  padding: 14px 24px;
}

.empty-barber-state {
  align-items: center;
  background: #fff8e1;
  border: 1px solid #ffe0a3;
  border-radius: 10px;
  color: #7a5a00;
  display: flex;
  font-size: 12px;
  padding: 10px 12px;
}

@media (max-width: 599px) {
  .booking-card {
    border-radius: 0 !important;
  }

  .booking-intro,
  .booking-step-title,
  .v-window-item > .v-card__text {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .service-menu .service-option {
    min-height: 66px;
  }

  .service-menu,
  .barber-menu,
  .time-menu {
    min-width: calc(100vw - 32px) !important;
  }

  .service-menu__list,
  .barber-menu__list {
    max-height: 56vh;
  }

  .time-menu__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: 48vh;
  }

  .booking-context,
  .booking-confirmation-summary__grid {
    grid-template-columns: 1fr;
  }

  .booking-confirmation-summary__grid > div:last-child {
    grid-column: auto;
  }
}
</style>
